import { render, staticRenderFns } from "./Riders.vue?vue&type=template&id=035bfa74"
import script from "./Riders.vue?vue&type=script&lang=js"
export * from "./Riders.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Riders.vue?vue&type=style&index=1&id=035bfa74&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports